export default __webpack_public_path__ + "static/media/table_view_icon.e5b0bec8.svg";